<template>
    <table class="ui-info-table">
        <tbody>
            <slot>
                <tr v-for="row in rows" :key="row.label">
                    <th scope="row">{{ row.label }}</th>
                    <td class="text-right">{{ row.value }}</td>
                </tr>
            </slot>
        </tbody>
    </table>
</template>

<script setup lang="ts">
export interface InfoTableRow {
    label: string;
    value: string | number;
}

withDefaults(
    defineProps<{
        rows?: InfoTableRow[];
    }>(),
    { rows: () => [] },
);
</script>
